var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eblPmJDFvRk1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eblPmJDFvRk4-fill",
    x1: 9.24048,
    y1: 27.1602,
    x2: 43.6412,
    y2: 27.1602,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk4-fill-0",
    offset: "19%",
    stopColor: "#0186d0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk4-fill-1",
    offset: "63%",
    stopColor: "#75d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk4-fill-2",
    offset: "100%",
    stopColor: "#0186d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eblPmJDFvRk5-fill",
    x1: 9.24048,
    y1: 53.6757,
    x2: 52.9054,
    y2: 53.6757,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk5-fill-0",
    offset: "19%",
    stopColor: "#0186d0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk5-fill-1",
    offset: "63%",
    stopColor: "#1b98d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk5-fill-2",
    offset: "100%",
    stopColor: "#0186d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eblPmJDFvRk5-stroke",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk5-stroke-0",
    offset: "0%",
    stopColor: "#0186d0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk5-stroke-1",
    offset: "100%",
    stopColor: "#05629a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eblPmJDFvRk6-fill",
    x1: -0.023682,
    y1: 27.0444,
    x2: 52.9054,
    y2: 27.0444,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk6-fill-0",
    offset: "19%",
    stopColor: "#0186d0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk6-fill-1",
    offset: "63%",
    stopColor: "#1b98d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk6-fill-2",
    offset: "100%",
    stopColor: "#0186d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eblPmJDFvRk6-stroke",
    x1: 0,
    y1: 0.5,
    x2: 0.945067,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk6-stroke-0",
    offset: "0%",
    stopColor: "#0186d0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eblPmJDFvRk6-stroke-1",
    offset: "100%",
    stopColor: "#05629a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.376962 0 0 14.607301 133.419924 51.137629)",
    clipPath: "url(#eblPmJDFvRk7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-.214247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eblPmJDFvRk4",
    d: "M9.24048,21.0557v11.98L26.4409,43.1798l2.3741-1.325v-23.8797L38.8929,23.784v11.9878l4.7483-2.7361v-11.98L26.4409,11.1426L9.24048,21.0557Z",
    clipRule: "evenodd",
    fill: "url(#eblPmJDFvRk4-fill)",
    fillOpacity: 0,
    fillRule: "evenodd",
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "eblPmJDFvRk5",
    d: "M9.24048,48.7103v5.3549L26.4409,63.9783L52.9054,48.726v-5.3549L26.4409,58.6234L9.24048,48.7103Z",
    clipRule: "evenodd",
    fill: "url(#eblPmJDFvRk5-fill)",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "url(#eblPmJDFvRk5-stroke)",
    strokeDashoffset: 111.505089,
    strokeDasharray: 111.505089
  }), /*#__PURE__*/React.createElement("path", {
    id: "eblPmJDFvRk6",
    d: "M-0.023682,15.7026v33.0314L4.97684,51.6169v-33.0529L26.4409,6.19258L47.9049,18.564v16.9629L26.4409,47.8983L9.24048,37.9323v5.7932L26.4409,53.6387L52.9054,38.3863v-22.6837L26.4409,0.450195L-0.023682,15.7026Z",
    clipRule: "evenodd",
    fill: "url(#eblPmJDFvRk6-fill)",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "url(#eblPmJDFvRk6-stroke)",
    strokeDashoffset: 322.985551,
    strokeDasharray: 322.985551
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eblPmJDFvRk7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 64,
    rx: 0,
    ry: 0,
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMotion);
export default __webpack_public_path__ + "static/media/logo-motion.e1b007c4cc8a0aeb3ea919f8869bf10a.svg";
export { ForwardRef as ReactComponent };